import {
  ChangeDetectionStrategy,
  Component,
  inject,
  Injector,
  input,
  OnInit,
  signal,
} from '@angular/core';
import { ResolvableModal } from '@softline/ui-core';
import { DeliveryNote } from '../../types/delivery-note';
import { Vehicle } from '../../types/vehicle';
import { DeliveryNoteService } from '../../services/delivery-note.service';
import { DeliveryNoteCardComponent } from '../../components/delivery-note-card/delivery-note-card.component';
import { IconComponent, LoadingSpinnerComponent } from '@softline/ui-core';
import { handleRequestError } from '@softline/application';

@Component({
  selector: 'soft-sscc-search-result-dialog',
  imports: [DeliveryNoteCardComponent, IconComponent, LoadingSpinnerComponent],
  templateUrl: './sscc-search-result-dialog.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SsccSearchResultDialog
  extends ResolvableModal<{ deliveryNote: DeliveryNote; vehicle: Vehicle } | null>
  implements OnInit
{
  private readonly deliveryNoteService = inject(DeliveryNoteService);
  private readonly injector = inject(Injector);

  readonly deliveryNotes = input.required<DeliveryNote[]>();

  readonly step = signal<1 | 2>(1);
  readonly selectedNote = signal<DeliveryNote | null>(null);
  readonly vehicles = signal<Vehicle[]>([]);
  readonly isLoadingVehicles = signal(false);

  ngOnInit(): void {
    if (this.deliveryNotes().length === 1) {
      this.selectDeliveryNote(this.deliveryNotes()[0]);
    }
  }

  async selectDeliveryNote(note: DeliveryNote): Promise<void> {
    this.selectedNote.set(note);
    this.step.set(2);
    this.isLoadingVehicles.set(true);
    try {
      const result = await this.deliveryNoteService.getVehicles(note.id);
      this.vehicles.set(result);
    } catch (e) {
      handleRequestError(e, this.injector, { show: true });
    } finally {
      this.isLoadingVehicles.set(false);
    }
  }

  selectVehicle(vehicle: Vehicle): void {
    const note = this.selectedNote();
    if (!note) return;
    this.resolve({ deliveryNote: note, vehicle });
  }
}
